import { FC, ReactElement } from 'react';
import { Button } from './styled';

type Props = {
  children: ReactElement;
  enabled?: boolean;
  onClick?: (e: any) => void;
};

const IconButton: FC<Props> = ({ children, enabled = true, onClick }) => {
  return (
    <Button
      onClick={onClick}
      type="button"
      data-testid="icon-button"
      disabled={!enabled}
    >
      {children}
    </Button>
  );
};

export default IconButton;
